export default __webpack_public_path__ + "957ea80231dc93297301cf5dee9e2d65.png";